export default __webpack_public_path__ + "static/media/arrow_down_filter_2.3c23e6b2.svg";